module.exports = __webpack_public_path__ + "img/apply_header.020be2c5.png";